<template>
  <div class="asc-error-type-icon">
    <div class="asc-error-type-icon--single">
      <asc-icon icon="square" :color="getBgColor" :size="14"></asc-icon>
    </div>
  </div>
</template>

<script>
import AscIcon from './AscIcon'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscErrorTypeIcon',

  components: {
    AscIcon,
  },

  props: {
    errorType: {
      type: String,
      required: true,
    },
  },

  computed: {
    getBgColor() {
      if (this.errorType === 'FDE') {
        return variables.accent700
      } else if (this.errorType === 'CMM') {
        return variables.accent600
      } else if (this.errorType === 'MM') {
        return variables.accent500
      } else if (this.errorType === 'NCMM') {
        return variables.accent300
      } else if (this.errorType === 'MMO') {
        return variables.accent100
      }

      return ''
    },
  },
}
</script>
